import React from 'react';

function BoxedContainer({ children, className = 'boxed' }) {
  return (
    <div
      className={`container mx-auto px-4 3xl:px-0 w-full lg:w-[80%] relative
      ${className === 'boxed' ? 'xl:!max-w-[1570px]' : ''}
      ${className === 'faq' ? 'lg:!max-w-[970px]' : ''}
      ${className === 'regular' ? 'xl:!max-w-[1170px]' : ''}
      ${className === 'form' ? 'lg:!max-w-[770px]' : ''}
      ${className === 'full-width' ? 'xl:!max-w-full' : ''}`}
    >
      {children}
    </div>
  );
}

export default BoxedContainer;
